// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/es7.map.of.js
// module id = 206
// module chunks = 0 1